import { createSlice } from "@reduxjs/toolkit";

const giftSlice = createSlice({
  name: "gift",
  initialState: {
    loading: false,
    data: null,
    error: null,
    isOtpSent: false,
    giftCreated: false,
  },
  reducers: {
    getGiftHistoryRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getGiftHistorySuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
    },
    getGiftHistoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createGiftRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.successMessage = null;
      state.giftCreated = false;
    },
    createGiftSuccess: (state,action) => {
      state.loading = false;
      state.isOtpSent = false;
      state.giftCreated = true;
    },
    createGiftFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.giftCreated = false;
    },
    generateGiftOtpRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.isOtpSent = false;
    },
    generateGiftOtpSuccess: (state) => {
      state.loading = false;
      state.isOtpSent = true; 
    },
    generateGiftOtpFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isOtpSent = false;
    },
    verifyGiftOtpRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    verifyGiftOtpSuccess: (state) => {
      state.loading = false;
      state.isOtpSent = false; 
    },
    verifyGiftOtpFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetGiftState: (state) => {
        state.giftCreated = false;
   },
  },
});

export const {
  getGiftHistoryRequest,
  getGiftHistorySuccess,
  getGiftHistoryFailure,
  createGiftRequest,
  createGiftSuccess,
  createGiftFailure,
  generateGiftOtpRequest,
  generateGiftOtpSuccess,
  generateGiftOtpFailure,
  verifyGiftOtpRequest,
  verifyGiftOtpSuccess,
  verifyGiftOtpFailure,
  resetGiftState,

} = giftSlice.actions;

export default giftSlice.reducer;
